import { dateOnly } from '@/types/models'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ReturnTypes = string | number | dateOnly | Date | any[]

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getValueFromArray = (item: any, valueArray: Array<string>): ReturnTypes =>
  valueArray.length > 1
    ? getValueFromArray(item[valueArray[0]], valueArray.slice(1))
    : item[valueArray[0]]

const getValueFromString = <T>(item: T, valueStr: string) =>
  getValueFromArray(item, valueStr.trim().split('.'))

export default getValueFromString
